export const FRENCH_PHONE_NUMBER_REGEX = /^(?:\+33|0|\+262)[1-9]\s?(?:\d{2}\s?){4}$/; // Test Regex online : https://regex101.com/r/e6ijpX/2

export const FRENCH_SIRET_REGEX = /^(?:\d{3}\s?){3}\d{5}$/; // Test Regex online : https://regex101.com/r/0IuJb7/1

export const EMAIL_ADDRESS_REGEX =
  /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[^"]+)*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/;

export const FRENCH_CADASTRE_REGEX = /^[0-9]{8}[A-Z]{2}[0-9]{4}$/; // Test Regex online : https://regex101.com/r/MIrFY1/2

export const FRENCH_ZIP_CODE_REGEX = /^[0-9]{5}$/;

export const FRENCH_NAF_CODE_REGEX = /^[0-9]{2}\.?[0-9]{2}[a-zA-Z]{1}$/; // Test Regex online: https://regex101.com/r/aHxe5N/1 ; For details on the NAF CODE format, see: https://www.economie.gouv.fr/entreprises/activite-entreprise-code-ape-code-naf

export const FRENCH_BRGM_FICHE_RISQUE_URL_REGEX =
  /^(?:https:\/\/fiches-risques\.brgm\.fr\/georisques\/infosols\/classification\/)([a-zA-Z0-9]*)$/i; // Test Regex online: https://regex101.com/r/cE0iSq/1

export const COLAS_INTERNAL_EMAIL_REGEX = /^([a-zA-Z0-9_.-]+)@colas\.com$/;

export const LATITUDE_COORDINATE_REGEX = /^(\+|-)?([0-8]?\d|90)(\.\d+)?$/;

export const LONGITUDE_COORDINATE_REGEX = /^(\+|-)?((1[0-7]\d|\d{1,2})|180)(\.\d+)?$/;
